module.exports = __webpack_public_path__ + "img/telegram.c3f57ef2.svg";